import { AxiosResponse } from 'axios';
import { Visit } from '../../features/past-visits/types';
import { API } from '../../utils/axios';
import { APIResponseStatus } from '../types';

interface GetVisitsParamsType {
  limit?: number;
  offset?: number;
  status?: string;
  order?: 'ASC' | 'DESC';
  business_hours?: boolean;
  pt_id?: string;
  total?: boolean;
  uuid?: string;
}

interface VisitResponseResource {
  resourceType: string;
  type: string;
  total: number;
  entry: { resource: Visit }[];
}

class PastVisitsService {
  static async getVisits(params: GetVisitsParamsType): Promise<VisitResponseResource> {
    const response = await API.post<any, AxiosResponse<APIResponseStatus<VisitResponseResource>>>(
      'v1/resources/Visit/_search',
      params,
    );
    return response.data.resource as VisitResponseResource;
  }

  static async getVisit(uuid: string) {
    const response = await API.get<any, AxiosResponse<APIResponseStatus<Visit>>>(
      `v1/resources/Visit/${uuid}`,
    );
    return response.data;
  }
}

export default PastVisitsService;
